module.exports = __webpack_public_path__ + "static/media/2019_conf_Anticipatory_Design_Future_Experience.74b5e4e5.png";